import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";
import AddInIds from "@/constants/AddInIds";
import { useAddinData } from "@/hooks/addins/useAddinData";

type ExternalLinkDetails = {
  id: "external-link";
  url: string;
};

/**
 * HelpLinkButton
 * - Loads the stored external link (details.id === "external-link")
 * - If present, shows an icon-only button (question mark)
 * - On hover, shows "Help" (customizable via props)
 * - On click, opens the link in a new tab
 */
const HelpLinkButton: React.FC = () => {
  const {
    data: items = [],
    isLoading,
    isFetching,
    error,
  } = useAddinData<ExternalLinkDetails>(AddInIds.externalLink);
  const { t } = useTranslation();
  const stored = useMemo(() => items.find(i => i.id === "external-link") ?? null, [items]);

  const handleClick = () => {
    const url = stored?.url?.trim();
    if (!url) return;
    window.open(url, "_blank", "noopener,noreferrer");
  };

  if (isLoading || isFetching || error || !stored?.url) return null;

  return (
    <Tooltip title={t("common.help")} arrow>
      <span>
        <IconButton size="small" color="primary" aria-label="help" onClick={handleClick}>
          <HelpOutlineIcon />
        </IconButton>
      </span>
    </Tooltip>
  );
};

export default HelpLinkButton;
